import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScRemoveSync implements ICommand
{

	public DBID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.DBID = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.DBID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScRemoveSync();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'DBID(Q)='+this.DBID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30009;
	}

	public getCmdName() : string
	{
		return 'ScRemoveSync';
	}

}
